import { memo } from "react";
import Hero from "../components/Home/Hero";
import AboutUs from "../components/Home/AboutUs";
import Benefits from "../components/Home/Benefits";
import FeaturedPVTModels from "../components/Home/FeaturedPVTModels";
import FeaturedBlog from "../components/Home/FeaturedBlog";
import Contact from "../components/Home/Contact";
import useDocumentTitle from "../hooks/useDocumentTitle";
import useImagePreloader from "../hooks/useImagePreloader";
import LoadingOverlay from "../components/LoadingOverlay";

import heroImage from "/images/Home/Hero.webp";
import aboutUsImage from "/images/Home/AboutUs.webp";
import benefitsImage from "/images/Home/Benefits.webp";
import pvtImage from "/images/PVT/PFZ_201.webp";
import blogPost1 from "/images/Blog/BlogPost1.webp";
import blogPost2 from "/images/Blog/BlogPost2.webp";
import blogPost3 from "/images/Blog/BlogPost3.webp";
import solarPropImage from "/images/Home/PVTprop.webp";

const Home = memo(function Home() {
  useDocumentTitle("home");

  const imagesToLoad = [
    heroImage,
    aboutUsImage,
    benefitsImage,
    pvtImage,
    blogPost1,
    blogPost2,
    blogPost3,
    solarPropImage,
  ];

  const loading = useImagePreloader(imagesToLoad);

  const blogImages = {
    post1: blogPost1,
    post2: blogPost2,
    post3: blogPost3,
  };

  return (
    <>
      {loading && <LoadingOverlay />}
      <main>
        <Hero heroImage={heroImage} />
        <AboutUs aboutUsImage={aboutUsImage} />
        <Benefits benefitsImage={benefitsImage} />
        <FeaturedPVTModels pvtImage={pvtImage} />
        <FeaturedBlog blogImages={blogImages} />
        <Contact solarPropImage={solarPropImage} />
      </main>
    </>
  );
});

export default Home;
